import { useBreadcrumb } from "features/breadcrumbs";
import Unidades from "components/Features/Unidades/ListUnidades";
import { useCurrentTenant } from "features/auth/tenant.store";
import Container from 'components/Container';

function UnidadeListagemPage() {
  useBreadcrumb([
    { name: "Administração" },
    { name: "Cadastros" },
    { name: "Unidades", url: "/cadastros/unidades" },
  ]);

  const { tenant } = useCurrentTenant();

  return (
    <Container>
      <Unidades isCondominio={false} tenantId={tenant.id} />
    </Container>
  );
}

export default UnidadeListagemPage;
